import { render, staticRenderFns } from "./AdditionalNoteTab.vue?vue&type=template&id=178fdfe5&scoped=true&"
import script from "./AdditionalNoteTab.vue?vue&type=script&lang=js&"
export * from "./AdditionalNoteTab.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalNoteTab.vue?vue&type=style&index=0&id=178fdfe5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178fdfe5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
